export default __webpack_public_path__ + "static/media/tech.70248fe7.gif";